import React, { Component } from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

import bg from '../../assets/images/sidebar/dog-2.png';

import Button from './../common/button';
import SectionAside from './../common/sectionAside';
import ServiceReceipt from './../common/serviceReceipt';

const Section = Styled.section`
display: grid;
grid-template-columns: 25fr 60fr;
background-color: ${color.tertiary};
height: 100vh;
@media only screen and (max-width: 700px){
grid-template-columns: 1fr;
};
`;

const SectionWrapper = Styled.section`
height: 100vh;
display:grid;
grid-template-rows:  1fr max-content;
place-items:center;
`;

const SectionBody = Styled.section``;

const SectionHeader = Styled.header`
margin: 2rem 0;
`;

const SectionHeading = Styled.h2`
max-width: 30ch;
line-height: 1;
color:${color.primary};
`;

const SectionFooter = Styled.footer`
width: 100%;
background-color:${color.white};
padding: 1rem;
text-align:center;
&>*{margin:0  0.5rem;}
`;

class ScheduleFour extends Component {
  state = {};

  render() {
    const { onNext, onPrev } = this.props;

    return (
      <Section>
        <SectionAside
          items={[
            'A photo update for you along with chat about the service',
            'Notifications of sitter arrival and departure times',
            'Treats for your pet, with your permission of course',
          ]}
          image={bg}
        />
        <SectionWrapper>
          <SectionBody>
            <SectionHeader>
              <SectionHeading>
                Almost there, let’s just confirm all the details.
              </SectionHeading>
            </SectionHeader>

            <ServiceReceipt
              image={''}
              type="Dog walk"
              name="Ginger"
              price="15"
              times={['Morning', 'Evening']}
              recurring={5}
              paymentType={'card'}
            />
          </SectionBody>

          <SectionFooter>
            <Button onClick={onPrev} type={'light'} text={'Back'} rounded />
            <Button
              onClick={onNext}
              type={'primary'}
              text={'Schedule Service'}
              rounded
            />
          </SectionFooter>
        </SectionWrapper>
      </Section>
    );
  }
}

export default ScheduleFour;
